import { render, staticRenderFns } from "./CardPropertyListValue.vue?vue&type=template&id=1af4a176&"
import script from "./CardPropertyListValue.vue?vue&type=script&lang=js&"
export * from "./CardPropertyListValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn,QTooltip,QSelect} from 'quasar'
component.options.components = Object.assign({QBtn,QTooltip,QSelect}, component.options.components || {})
